/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Rail_App_BodyInputs */

const en_portal_rail_app_body = /** @type {(inputs: Portal_Rail_App_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reminders and new plans arrive as notifications.`)
};

const pl_portal_rail_app_body = /** @type {(inputs: Portal_Rail_App_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przypomnienia i nowe plany przychodzą jako powiadomienia.`)
};

/**
* | output |
* | --- |
* | "Reminders and new plans arrive as notifications." |
*
* @param {Portal_Rail_App_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_rail_app_body = /** @type {((inputs?: Portal_Rail_App_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Rail_App_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_rail_app_body(inputs)
	return en_portal_rail_app_body(inputs)
});